module.exports = __webpack_public_path__ + "img/show.fcd21571.svg";